import datalayerActions from './datalayer-actions';

/**
 * Custom datalayer push events for product page
 */

function init() {
  setButtonAnalyticEvents();
  setChatAnalyticEvents();
  setCarouselAnalyticEvents();
}

/**
 * Get vehicle data from the GTM data layer object for use in custom events. This works because the data is already
 * pushed to the datalayer by an inline script tag on all product pages.
 * @returns { Object }    Vehicle data
 */
function getPageInfo() {
  return window.dataLayer.find(item => item.pageInfo !== undefined)?.pageInfo;
}

/**
 * Push specified event, along with the page path and the vehicle data to the GTM data layer.
 * @param { String } eventName  event name
 */
function pushVehicleEventToDataLayer(eventName) {
  const vehicleData = getPageInfo();
  if(eventName && vehicleData) {
    datalayerActions.pushObjectToDatalayer({
      event: eventName,
      pagePath: window.location.pathname,
      ...vehicleData});
  }
}

/**
 * Set up datalayer push listeners for various CTA buttons on the product page.
 */
function setButtonAnalyticEvents() {

  const ctaButtons = document.querySelectorAll('[data-vehicle-gtm-click-event]');
  for (const button of ctaButtons) {
    button.addEventListener('click', (event) => {
      pushVehicleEventToDataLayer(button.dataset.vehicleGtmClickEvent);
    });
  }
}

/**
 * Set up analytics for chat button.
 */
function setChatAnalyticEvents() {
  // As the chat script is injected via GTM, it hasn't entered the DOM at this point. Thus, here we
  // add an indirect listener to the HTML element, which checks whether the chat box was opened.
  document.querySelector('html')?.addEventListener('click', (event) => {
    if (event.target.closest('div.sf-prem-bubble')) {
      const chatButton = document.querySelector('div.sf-prem-bubble');
      if (chatButton.classList.contains('sf-open')) {
        pushVehicleEventToDataLayer('hasChatted');
      }
    }
  });
}

/**
 * Set up analytics for image carousel.
 */
function setCarouselAnalyticEvents() {
  // Here we use a custom event added to the image carousel to keep tabs on the image view count.
  document.querySelector('.swiper').addEventListener('imageChange', (event) => {
    if (event.detail.views === 10) {
      pushVehicleEventToDataLayer('scrolled_ten_pictures');
    }
  });
}

export { init };
